import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, lastValueFrom, map, of } from 'rxjs';
import { environment } from 'src/environments/environment';
import {
  ApiResponseModel,
  CidadeDTO,
  Estado,
  TrackingList,
  TrackingModel,
  ZipcodeResponse
} from '../models';

@Injectable({
  providedIn: 'root'
})
export class OpenService {
  constructor(private http: HttpClient) {}

  private trackingBaseUrl(): string {
    return environment.trackingApiUrl || environment.subscriptionApiUrl;
  }

  findLocationByZipcode(zipcode: string): Promise<ZipcodeResponse> {
    return lastValueFrom(
      this.http
        .get<
          ApiResponseModel<ZipcodeResponse>
        >(environment.subscriptionApiUrl + 'open/location/cep/' + zipcode)
        .pipe(map((data) => data.result))
    );
  }

  listStates(): Promise<Array<Estado>> {
    return lastValueFrom(
      this.http
        .get<
          ApiResponseModel<Array<Estado>>
        >(environment.subscriptionApiUrl + 'open/location/states')
        .pipe(map((data) => data.result))
    );
  }

  listCities(codigoIBGE: number): Promise<Array<CidadeDTO>> {
    return lastValueFrom(
      this.http
        .get<
          ApiResponseModel<ApiResponseModel<Array<CidadeDTO>>>
        >(environment.subscriptionApiUrl + 'open/location/cities?stateId=' + codigoIBGE)
        .pipe(
          map(
            (data) => (data.result as ApiResponseModel<Array<CidadeDTO>>).result
          )
        )
    );
  }

  getShippingTracking(invoiceNumber: number): Promise<TrackingModel[]> {
    return lastValueFrom(
      this.http
        .get<
          ApiResponseModel<TrackingList>
        >(this.trackingBaseUrl() + 'open/tsimples/tracking/' + invoiceNumber)
        .pipe(
          map((data) => {
            if (!data.result) return [];
            try {
              return (JSON.parse(data.result as unknown as string) as TrackingList)
                .eventos?.map((e) => ({
                  ...e,
                  data_do_evento: new Date(
                    `${e.data_do_evento} ${e.hora_do_evento}`
                  ) as any
                }));
            } catch {
              return [];
            }
          }),
          catchError(() => of([]))
        )
    );
  }

  getShippingTrackingByPedidoV(pedidoV: string): Promise<TrackingModel[]> {
    return lastValueFrom(
      this.http
        .get<
          ApiResponseModel<TrackingList>
        >(this.trackingBaseUrl() + 'open/tsimples/order/tracking/' + pedidoV)
        .pipe(
          map((data) => {
            if (!data.result) return [];
            try {
              return data.result.eventos?.map((e) => ({
                ...e,
                data_do_evento: new Date(
                  `${e.data_do_evento} ${e.hora_do_evento}`
                ) as any
              }));
            } catch {
              return [];
            }
          }),
          catchError(() => of([]))
        )
    );
  }
}
